import React from 'react';
import {SpinnerChaseProps} from '../../@types/components/Spinner';
import classnames from '../../helpers/classnames';

export default class SpinnerChase extends React.Component<SpinnerChaseProps> {
    render() {
        return <div className={classnames({
            'spinner-chase': true,
            ['spinner-chase--' + (this.props.size || '')]: Boolean(this.props.size),
            ['spinner-chase--' + (this.props.color || '')]: Boolean(this.props.color),
            [this.props.className ?? '']: true,
        })}>
            {this.renderDots()}
        </div>;
    }

    protected renderDots(dotsNumber = 6) {
        const renderer = (_: any, i: number) => <div key={`spinner-chase-${i}-dot`} className="spinner-chase__dot"/>;

        return Array.from(Array(dotsNumber), renderer);
    }
}
